
    export default {
        name: "SupportCategoriesCard",
        props: {
            displayTitle: {
                type: String,
                default: ""
            },
            imageUrl: {
                type: String,
                default: ""
            },
	        imageWidth: {
				type: Number,
		        default: 70
	        },
	        sortOrder: {
				type: Number,
		        default: 0
	        },
            imageAlt: {
                type: String,
                default: ""
            },
            childCategories: {
                type: Array,
                default: []
            },
            onEnterCategory: {
                type: Function,
                default: null
            },
            currentCategory: {
                type: Array,
                default: []
            },
            urlName: {
                type: String,
                default: ""
            },
	        isNavVersion: {
				type: Boolean,
		        default: false
	        },
			baseUrl: {
				type: String,
                default: ""
			}
        }
    };
